import { Record as record, fromJS } from 'immutable';

import DisabledService from './records/search/DisabledService';
import Tutorial from './records/Tutorial';
import CompensationTicketType from '../delay-repay/src/records/compensation/TicketType';
import CompensationNonSeasonTicketType from '../delay-repay/src/records/compensation/NonSeasonTicketType';
import CompensationPurchaseLocation from '../delay-repay/src/records/compensation/PurchaseLocation';
import CompensationEvidenceType from '../delay-repay/src/records/compensation/EvidenceType';
import DelayRepayTicketType from '../delay-repay/src/records/TicketType';
import DelayRepayReason from '../delay-repay/src/records/Reason';
import DelayRepayTime from '../delay-repay/src/records/Time';
import DelayRepayPaymentRecord from '../delay-repay/src/records/PaymentMethod';
import {
    AppName,
    DelayRepayPaymentMethod,
    DelayRepayClaimReason,
    DelayRepayTicket,
    DelayRepayTicketClass,
    CompensationTicket,
    CompensationEvidence,
    CompensationPurchaseLocations,
    DurationTypes,
    JourneyPlannerLayout,
    Tutorials,
    JPListTutorialStages,
    JPGridTutorialStages,
    SeasonsTutorialStages,
    StationFinderTutorialStages,
    SmartcardTutorial,
    RailcardTutorial,
    CustomerTitles,
} from './constants/AppConstants';

const currentHost = window && window.location && window.location.host;

const defaults = {
    name: AppName.BOOKING_ENGINE,
    version: '',
    title: 'Booking Engine',
    environment: 'development',
    bookingEngineHost: currentHost,
    delayRepayHost: currentHost,
    autoDelayRepayHost: currentHost,
    baseHref: '',
    namespace: '',
    brandUrls: {},
    extraInfoSecretVersion: 'Shown in the <SecretVersion> component.',

    debug: false,
    a11y: false, //Enable or disable React-a11y

    //Api settings
    apiHost: 'localhost',
    apiPort: '443',
    apiProtocol: 'https',
    apiPath: '',
    apiAccessToken: '8gh2w38ho43o83hw48o4hg8h4g8',
    configApiHost: null, // overrides default apiHost
    configApiAccessToken: null, // overrides default access token
    forceCORSProxy: false, //If true force the app to use the cors proxy
    cookieDomain: [],

    //Widgets
    jpWidgetBundleUrl: null,

    //Brand config
    brand: 'thameslink',
    configServiceBrand: null, // Override to set different brand for confsvc
    tocCode: null, //The TOC code for this brand
    tocGroup: [],
    mainSiteUrl: 'http://www.thameslinkrailway.com',
    ticketsSiteUrl: null,
    plusBusUrl: 'http://plusbus.info/',
    groupSaveDetailsUrl: 'http://www.nationalrail.co.uk/times_fares/groupsave_calendar.html',
    ticketTermsAndConditions:
        'http://ojp.nationalrail.co.uk/service/ticketterms/show?&ticketTypeCode={ticketTypeCode}',
    threeDSecureCallbackUrl: '/3d-secure.html',
    threeDSecureTermUrlV1Payment:
        '/orders/{orderId}/payment/{paymentId}/3d-secure?x-customer-device={deviceToken}&callbackUrl={callbackUrl}',
    threeDSecureTermUrlV2Payment:
        '/orders/{orderId}/payment/{paymentId}/3d-secure/v2?x-customer-device={deviceToken}&callbackUrl={callbackUrl}',
    threeDSecureTermUrlV1Authorization:
        '/customers/keygo/resume/{paymentId}?callbackUrl={callbackUrl}',
    threeDSecureTermUrlV2Authorization:
        '/customers/keygo/resume/{paymentId}/v2?callbackUrl={callbackUrl}',
    cardLockId: undefined,
    cardLockUrl:
        'https://api.mite.pay360.com/cardlock/createToken?pan={cardNumber}&cvv={securityCode}&publishableId={publishableId}',
    paypalEnvironment: 'sandbox',
    enablePaypalPayLater: false,
    enablePaypalPayLaterVaultFlow: false,
    paypalPayLaterMinAmount: 2000,
    paypalPayLaterMaxAmount: 300000,
    pay360SessionReturnUrl: '/pay360-session.html',
    pay360SkinId: 1, // override this for each brand on test/prod
    pay360SkinKeyGoId: 1,
    legalUrl: 'https://www.thameslinkrailway.com/contact-us/terms',
    accessibilityStatementUrl: 'https://www.thameslinkrailway.com/terms-of-use/site-accessibility',
    ownerUrl: 'https://gtrailway.com/freedom-of-information',
    faqUrl: 'https://www.thameslinkrailway.com/contact-us/frequently-asked-questions',
    eTicketsUrl: null,
    eTicketsFaqUrl: 'https://www.thameslinkrailway.com/help-and-support/contact-us/faqs/etickets',
    contactUrl: 'https://www.thameslinkrailway.com/help-and-support/contact-us',
    smartcardLogo: '/images/smartcard-logo.png',
    loadSmartcardIllustration: '/images/smartcard/load-smartcard-gtr.png',
    loadSTicketIllustration: '/images/load-sticket.svg',
    smartcardReadMoreUrl: 'https://www.thameslinkrailway.com/tickets-and-fares/the-key-smartcard',
    delayRepayCompensationUrl: null,
    autoDelayRepayInformationUrl: 'https://www.thameslinkrailway.com/help-and-support/journey-problems/delay-repay/auto-delay-repay',
    smartcardPhoneNumber: '03450 26 47 00',
    customerServicesPhoneNumber: '03450 26 47 00',
    nationalRailConditionsUrl: 'https://www.nationalrail.co.uk/NRCOT',
    privacyPolicyUrl: 'https://www.thameslinkrailway.com/contact-us/terms/privacy-policy',
    googleMapPrimaryColour: '#00a5e2',
    keyGoInformationUrl: 'https://www.thameslinkrailway.com/keyGo',
    keyGoTermsAndConditionsUrl: '/files/keygo-conditions-of-use.pdf',
    keyGoCollectionMapUrl: 'http://southernrailway.com/keygo',
    helpUrl: 'https://www.thameslinkrailway.com/help',
    delayRepayUrl:
        'https://www.thameslinkrailway.com/help-and-support/journey-problems/delay-repay',
    googleMapsSrc: '//maps.googleapis.com/maps/api/js?callback=callback&libraries=places,geometry&key=',
    googleMapsApiKey: 'AIzaSyB5IuxzS7OotxO0oEEQmQkuG1OyS5Q1BCI', //Google maps api key, managed by the thomas.the.tank
    googleRecaptchaKey: '6LfAESkTAAAAAJel3dLFhw7lYUWqoNe8lBUa1tR8', //Google recaptcha api key, managed by the thomas.the.tank
    addisonLeeClientID: 'aa5abe2e8e9348daa1dd1c2f98c2596f',
    addisonLeeFrameSrc:
        'https://widget.partnerships.addisonlee.com/index.html?clientid={addisonLeeClientID}&sandbox=false',
    defaultDeliveryCountry: 'GBR',
    journeySelectorType: 'open', //The type of station selector to show on the point search page (open/closed)
    journeySelectorOptions: null, //If the type of journeySelector is closed, a list of valid origin destination combinations
    journeySelectorAdditionalOptions: null,
    journeyPlannerDefaultLayout: JourneyPlannerLayout.GRID,
    journeyPlannerDefaultCheapestSearch: false,
    journeyPlannerAllowDepartedServiceSearchTimeLimit: 4, // Hours threshold for allowing a search of already departed services
    allowSearchTypeChange: true,
    micrositeLogo: null,
    maxOutboundDays: 84, //The maximum number of days in the future you can search for
    maxSeasonStartPeriod: 'P21D',
    maxSeasonStartPeriodSmartcard: 'P21D',
    minAwaitingSmartcardProductDays: 5,
    minDeliveryLeadTimeInDays: 2, //Used to calculate the earliest date a monthly+ season ticket can be purchased for
    pivotalPostalHour: 16, //The cut-off time during the day for postal delivery, after which the lead time will be extended
    minTodOffset: 'PT5M', //The minimum time requires for TOD tickets
    minTodGTROffset: 'PT5M', //The minimum time fot GTR brands requires for TOD tickets
    minSmartcardOffset: 'PT2H', //The minimum time a brand requires for Smartcard tickets
    smartcardPreloadTimeLimit: 'PT2H', //Time limit when pregistering a smartcard that a ticket will still be preloaded onto the card
    keyGoMaxDurationBetweenTaps: 'PT4H35M', //Maximum duration between keygo journey entry and exit taps
    daySaveUrl: 'http://www.southernrailway.com/tickets-and-fares/ticket-types/daysave/',
    railcard1617WebsiteUrl: 'https://www.16-17saver.co.uk/',
    appStoreAppUrl: 'https://apps.apple.com/gb/app/thameslink-on-track/id908805038',
    googlePlayAppUrl: 'https://play.google.com/store/apps/details?id=com.thameslinkgreatnorthern.ontrack',
    inAppVersionEndingAppStoreUrl: null,
    inAppVersionEndingGooglePlayUrl: null,
    minServiceDelay: 5, // Minimum delay for a service (on arrival) before we draw attention to the fact
    fulfilmentOptionsLink:
        'https://www.thameslinkrailway.com/tickets/buy-tickets/ways-to-pay/delivery-options',
    myTicketLinkNRE: 'http://ojp.nationalrail.co.uk/service/wct/show',
    maxSavedAddresses: 10,
    daySaveAbsoluteDateRangeStart: null,
    daySaveAbsoluteDateRangeEnd: null,
    daySaveRelativeDateRangeStart: 3,
    daySaveRelativeDateRangeEnd: 84,
    daySaveDestinationNlc: null,
    discoverMoreUrl: null,
    showAdultBirthday: true,
    applePayMerchantName: 'Test Merchant',
    googlePayMerchantId: '',
    yourAccountHelpUrl: '',
    customerTitles: CustomerTitles,
    accessibilityInfoUrl: null,
    assistedTravelUrl: null,
    delayRepayBrochureUrl: null,
    registerDetailsImageUrl: '/images/registration/register-details-tl.png',
    registerSmartcardImageUrl: '/images/registration/register-smartcard.png',
    registerPreferencesImageUrl: '/images/registration/register-preferences-tl.png',
    icoUrl: 'https://ico.org.uk/',
    rewardPointsUrl: null,
    rewardPointsTermsUrl: null,
    rewardPointsTocUrl: null,


    createAccountBenefits: [
        'account.register.create.benefits.checkout',
        'account.register.create.benefits.refunds',
        'account.register.create.benefits.history'
    ],

    smartcardRegistrationBenefits: [
        'account.register.smartcard.benefits.tickets',
        'account.register.smartcard.benefits.app',
        'account.register.smartcard.benefits.queues',
        'account.register.smartcard.benefits.contactless',
        'account.register.smartcard.benefits.refunds'
    ],

    // Track and Trace
    trackAndTraceAppLink: 'https://covid19.nhs.uk',

    // Refunds
    /*
     * Flag combination to disable itso season refunds on a brand
     *  - enableItsoSeasonRefunds: false
     *  - enableAllowRefundsOnOtherBrands: true
     */
    refundUrl:
        'https://www.thameslinkrailway.com/paperticketrefund',
    enableUpdatedRefundCopy: true,
    refundCopyCutoverDate: '2026-04-01',
    industrialActionUrl: null,
    smartcardRefundUrl: null,
    sTicketRefundUrl: null,
    smartcardRefundFormUrl: null,
    smartcardRefundContactUrl: null,
    smartcardRefundInformationUrl:
        'http://www.nationalrail.co.uk/times_fares/ticket_types/46571.aspx',
    paperTicketRefundsUrl: null,
    eTicketRefundsUrl: null,
    enableSeasonRefundsMoreInfo: true,
    refundSurrenderDateMiddayCutOff: true,
    enableDayTicketRefunds: true,
    enableItsoSeasonRefunds: true,
    enableItsoDayTicketRefunds: false,
    enableAllowRefundsOnOtherBrands: false,
    enableNonStandardItsoSeasonRefundFromLink: true,
    displaySeasonRefundsZeroAdminFee: true,
    enablePurchaseHistoryDisclaimer: true,
    enableItsoRefundsSmartcardValidations: true,
    enableSelfServiceRefundDelay: false,
    selfServiceRefundDelayMinDelay: 3,
    selfServiceRefundDelayMaxDelay: 15,

    // Timeouts for waiting for processing orders
    awaitProcessingTimeout: 5000,
    awaitProcessingAttempts: 60,

    //Tags
    googleGTMID: 'GTM-WTCCQ23Q',
    widgetsGTMID: 'GTM-WMCGG5Q',
    gtmDataLayer: 'dataLayer',
    gtmCampaignWidget: 'On-Track-Widget',

    // Sitecore Personalise (SET only)
    sitecoreClientKey: null,
    sitecoreTargetURL: null,
    sitecorePointOfSale: null,
    sitecoreCookieDomain: null,
    googleSiteVerificationMeta: null,
    searchEngineNoIndex: false,

    // UserCentrics
    enableUsercentrics: false,
    usercentricsForceBanner: false,
    usercentricsSettingsId: null, // Override in brand-specific configs with value from UC admin
    usercentricsAutoblocking: true, // if you want UC to auto-block
    // map which consent category unlocks GTM
    usercentricsGtmCategory: "statistics", // or "marketing", etc.
    // UC service ID for GTM — preferred over category slug (stable across re-classifications)
    usercentricsGtmServiceId: null,
    enableCookiePreferences: false, // show "Change Preferences" button in footer

    // Sovendus Voucher Network (checkout promotion)
    enableCheckoutPromotion: false,
    sovendusTrafficSourceNumber: null,
    sovendusTrafficMediumNumber: null,
    sovendusFlexibleIframeUrl: 'https://api.sovendus.com/sovabo/common/js/flexibleIframe.js',
    usercentricsSovendusServiceId: null,
    usercentricsSovendusCategory: 'marketing',


    //Limit jp results to specific service providers
    serviceProviders: null,
    alwaysFilterByServiceProviders: true,

    // Sentry DSNs (legacy `raven` key names kept — they can be overridden per deployment)
    ravenDSN: 'https://c086582b3d514c8a97323da0d6deefa2@app.getsentry.com/72485',
    ravenDSNTAB: 'https://ce79d17425004678bc9bcfd2a03955bf@app.getsentry.com/72482',

    // CSP → Sentry endpoint (main web DSN)
    cspReportUri: 'https://app.getsentry.com/api/72485/security/?sentry_key=c086582b3d514c8a97323da0d6deefa2',

    //Security/login
    sessionShort: true,
    minPasswordLength: 8,
    autoLogoutMinutes: 30,
    autoLogoutWarningMinutes: 25,

    //Oyster/contactless further info
    oysterInfo: 'https://www.nationalrail.co.uk/tickets-railcards-and-offers/ticket-types/oyster-contactless-and-travelcards/',
    contactlessInfo: 'https://www.nationalrail.co.uk/tickets-railcards-and-offers/ticket-types/oyster-contactless-and-travelcards/',

    // Carbon Footprint
    carbonFootprint: 'https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2026',
    EPACalculationUrl: 'https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references',
    carbonFootprintCalculatorUrl: 'https://www.carbonfootprint.com/energyconsumption.html',

    // Libs
    leafletGeolocationUrl: 'https://unpkg.com/leaflet-geosearch@latest/dist/bundle.min.js',

    //Amend time period
    amendMinMinutesLeft: 30,

    //Feature Flags - flexi (only used for Flexi account screen)
    enableFlexi: true,

    // Enable map on the Search Page
    enableMap: true,

    //Use OpenStreetMaps instead of googlemaps
    enableOpenMaps: false,

    // Feature Flags - sTickets
    enableSTickets: false,
    enableSTicketsDelivery: true,
    enableSTicketsRefunds: false,
    enableSTicketsList: false,
    hideSTicketsDelivery: false,

    // Feature Flags - split ticketing
    enableSplitTicketAmends: false,
    enableSplitTicketRefunds: false,
    enableSplitTicketAvailableModal: false,

    //Feature Flags - smartcard
    enableActivateSmartcard: false,
    enableSmartcardMaintenance: false,
    enableSmartcard: true,
    enableSmartcardAtSignup: true,
    enableSmartcardAccountApplication: true,
    enableDefaultSmartcardAtSignup: false,
    enableSmartcardPaperTransfers: false, //Allow transferring paper tickets onto smartcards
    enableSmartcardTransferAtSignUp: false,
    enableSmartcardEditAddress: false,
    enableSmartcardDiffDeliveryOptAlert: false,
    enableSmartcardTutorial: ':[2020-10-01]',
    enablePaperTransferCollectionFilter: false, //Checks if collection locations are open 3 hours or more on all working days of the week
    enableTocOnlySearch: false,
    enableSmartcardCTA: false,
    enableChildSmartcardMessage: false,
    enableProductPreload: true,
    enableDayTicketPreload: false,
    enableSmartPlusBus: false,
    smartcardPhotoMimeTypes: ['image/jpeg', 'image/jpg', 'image/png'],
    enableSmartcardSelfRegistration: false,
    enableSmartcardSelfRegistrationLink: false,
    enableSmartcardAssociations: false,
    enableSmartcardAddressChange: false,
    enableSmartcardSeasonEnforcement: false,
    enableSmartcardPhotoReplacement: false,
    enableChildSmartcardTransitioning: false,
    enableChildSmartcardRegistration: true,
    enableForcedAppCollectionForTwoHourCollectionWindow: false,
    enableFooterOwnerLink: true,
    enablePendingActionlistSmartcardDeliveryBlocking: false,
    enableExpiringSmartcardConfirmation: false,

    //Feature Flags - keyGo
    enableKeyGoRegistration: true,
    disableKeyGoRegistrationUntilDate: '2018-01-31',
    enableKeyGo: true,
    enableKeyGoRegistrationAtSignup: false,
    enableKeyGoRegistrationWarning: true,
    enableKeyGoCTA: false,
    enableKeyGoCollectionInfo: true,
    enableKeyGoMinTopup: true,
    enableKeyGoSelfCompleteJourneys: false,
    enableKeyGoReimbursement: false,
    enableKeyGoSignposting: false,
    enableKeyGoPaymentCardExpiryReminder: false,
    enableKeyGoRailcards: false,
    enableHostedKeyGoPayments: false,

    //Feature Flags - banners
    enableBetaBanner: false,
    disableBetaBannerDate: null,
    bannerMessageDismissExpires: 60 * 60 * 12,
    enableMicrositeBanner: false,

    //Feature Flags - airport offers (GX perks promotion)
    enableAirportOffers: false,
    airportOffersTermsUrl: null,

    //Feature Flags - journey notifications
    journeyNotificationDismissExpires: 60 * 60 * 24,

    //Feature Flags - journey planning
    enableViaAvoid: true,
    enableSeatingPreferences: true,
    enablePlusBus: true,
    enableSeasonTickets: true,
    enableWeeklySeasonTickets: true,
    enableFlexiSeasonTickets: true,
    enableFourWeeklySeasonTickets: false,
    enableQuarterlySeasonTickets: false,
    enableSixMonthlySeasonTickets: false,
    enableOtherTickets: true,
    enableDaySave: false,
    enableHiddenDaySave: false,
    enableRoversRangers: true,
    enableAddisonLeeWidget: true,
    enableRailcard1617: true,
    enableJobCentrePlus: true,
    enableRailcardVeterans: true,
    enableDeleteRailcards: false,
    enableBrandTocForServices: false, //Show the TOC when listing services
    enableDelayRepay: true,
    enableDelayRepayHandoff: false,
    enableDelayRepayCaptcha: true,
    enableAutoDelayRepay: false,
    enableOneClickDelayRepay: false,
    enableRewardCodes: false,
    autoDelayRepayMaxJourneys: 50,
    autoDelayRepayRemainingJourneysWarningThreshold: 10,
    enableDelayRepayWarningMessage: false,
    enableCompensationWhitelist: false,
    enableCompensationSeason: false,
    enableCompensationNonSeason: false,
    disableWhitelistCompensationClaim: false,
    disableSeasonTicketCompensationClaim: false,
    disableNonSeasonCompensationClaim: false,
    disableStationFinder: false,
    enableBuyButtonOnResetPassSuccess: false,
    enableOpenReturnInfoModal: true,
    enableDepartNow: true,
    enableEligibleServicesModal: true,
    openReturnGoodValueMultiplier: 1.9,
    enableUsualSeatingAvailabilityModal: false,
    enableJourneySupport: false,
    enableSeatFinder: false,
    seatingAvailabilityButtonShowDurationHours: 48,
    enablePromoDiscount: false,
    enablePromoDiscountValidation: false,
    enableBestFareFinderAndRecentOrdersJPWidget: false,
    enableAdditionalStationInfo: false,
    enablePlatformFormationDetails: false,
    platformFormationDetailsTocCodes: ['TL', 'GN', 'GX', 'SN'],
    enableAirConditioningIndicator: false,

    //Feature Flags - checkout
    enableLogoutRedirect: true,
    enableHeaderBasket: true,
    enableOrderRefundDetails: true,
    enableOrderAmendDetails: true,
    enableEVoucherAmends: true, // This is ok for Pay360Api, but requires some backend work for Pay360Hosted
    enableEVoucherCheckout: true,
    enablePaypal: true,
    enableCardPayments: true,
    enablePay360Api: true,
    enablePay360Hosted: false,
    enableBraintreeCardPayments: false,
    enableApplePay: false,
    enableGooglePay: false,
    enableGooglePayAmends: false,
    enableAmexPayments: true,
    enableDuplicateOrderCheck: false,
    enableSafeKey: true,
    enableSavedPhotocards: true,
    enableTicketDownload: false,
    enableRegistrationDuringCheckout: true,
    disableSelfPrint: false,
    disableETickets: true,
    enableETicketAmends: false,
    enableAdvanceToWalkUpAmends: false,
    disableTOD: false,
    disableCCST: false,
    enableFreeTicketCollectionInfo: false,
    enableFulfilmentOptionsInfo: false,
    enableReorderFromPurchaseHistory: true,
    enableDownloadReceipt: false,
    enableFavouriteTickets: true,
    enableFavouriteTicketChanges: true,
    enableDefaultFulfilmentEticket: false,
    enableDefaultFulfilmentSmartcard: false,
    enableEticketAccountSection: false,
    enableCustomerOnlyDelayRepay: false,
    enableBookingFee: false,
    enableDiscountCode: false,
    enableVoucherCode: false,
    enableCheckDeliveryOptionsForFulfilmentCTA: true, // Hide the Details on all fulfilment options CTA if there's only 1 delivery option available,
    enableFlexiKeyGoWarningModal: false,
    enableTrackAndTraceAppLink: true,
    enableBookingConfirmationDelayRepayInfo: false,
    enableDeliveryOptionWatermarkImages: false,
    enableRewardPoints: false,
    enableETicketByPost: false,
    enableCharityRoundUp: false,
    hidePostalDeliveryOptions: false,

    // Feature Flags - account page
    enableEVouchers: true,
    enableNewAccountMenuView: false,
    enablePassengerAssist: false,
    enablePassengerAssistBookingWidget: false,
    enablePurchaseFlowReservations: false,
    enableStandaloneReservations: false,

    // Feature Flags - disruption alerts
    enableDisruptionAlerts: false,
    enableDisruptionAlertsAccountSection: false,
    enableDisruptionAlertsEditing: false,
    enableDisruptionAlertsCreateButton: false,

    enableTimetableAlertsWidget: false,
    enableTimetableAlertsWidgetAdvancedOptions: false,
    enableAlertsPreferenceOptions: false,
    enableAlertsLimitInfo: false,
    enableDefaultTimetableAlert: false,

    // Feature Flags - preference centre
    enableEmailMarketing: true,
    enableSmsMarketing: false,
    enableServicePreference: true,
    enableServicePreferenceHelpIcon: false,
    enablePromotionsPreference: true,
    enablePromotionsPreferenceHelpIcon: true,
    enableProductsPreference: false,
    enablePrefCentreUnder16Warning: false,
    enableMarketingConsents: false,

    // DataGuard "Manage" progressive consent widget — per-env IDs/URL in brand configs
    enableDataGuardConsentWidget: false,
    dataGuardWidgetTemplateId: null,
    dataGuardWidgetRuleSetId: null,
    dataGuardWidgetScriptUrl: null,
    // Client-side suppression cookie (CORE-23082) — masks CORE-22346's stale rule-set reads.
    // Only TPE sets a real value; other brands don't run the widget.
    dataGuardSuppressionExpiryDays: null,

    // Feature Flags - misc
    enableInAppTokenRefreshOnPageLoad: true,
    enableFooterFaqsLink: true,
    enableFooterPaymentMethods: true,
    enableFooterLinkInternal: [],
    enableForceScrollRegistration: false,
    enableFirstClassAccessibilityInfo: true,
    enablePostCodeLookUp: true,
    enableBacsValidation: true,
    enableAccountRailcards: false,
    enableAddAccountRailcards: false,
    enableSetPasswordAndPreferencesPage: false,
    enableModalHistoryTracking: true,
    enableETicketRefundAdminFee: false,
    enableETicketRefundBlockingForTravelToday: false,
    enableConfirmEmailField: false,
    enableAccountDeletion: false,
    enableHistoricETickets: false,


    // Feature Flags - OCDR charities
    enableOcdrCharityReimbursementMethod: false,
    enableRailwayChildrenCharity: false,
    enableDameKellyHolmesCharity: false,
    enableRSPCACharity: false,
    enableSamaritansCharity: false,
    enableCancerResearchCharity: false,
    enableGreatOrmondStreetCharity: false,
    enableNhsCharity: false,
    enableDecCharity: false,

    //Feature Flags - On Track App widget
    enableOnTrackAppWidget: true,

    //Feature Flags - Basket widget
    enableBasketWidget: false,
    enableLogoRedirectToSearchPage: true,

    hideSeatingPreferencesButton: false,

    //Feature Flags - addresses
    enableUserAddresses: true,

    preselectedEmailMarketing: true,

    //Feature Flags - TL/GN split modal
    showBrandSplitModal: false,

    // Feature Flags - carbon emissions
    enableCarbonCalculator: false,

    // eTicket pagination defaults
    eTicketDefaultPage: 1,
    eTicketDefaultLimit: 10,

    showRailcardExpiryInfo: false,

    disableDayTicketsAdminFee: false,

    brandedMenuNav: null,
    brandedAccountMenuNav: null,

    disableAppTracking: false,
    enableNativeReordering: false,

    // Digital railcards
    enableDigitalRailcards: false,

    // null | Array<TOCCode>
    // Display warnings for services with counted places on the following TOCs:
    showCountedPlaceWarnings: null,

    enableCACIv2: false,

    /*
        Content Security Policy

        IMPORTANT: Turning this off from here DOES NOT WORK.
        To disable the CSP, you MUST disable it in a per brand basis in the brand configs.

        This is a BUILD TIME feature flag only, which cannot be overridden at runtime
        using env vars in Portainer.
    */
    enableContentSecurityPolicy: false,
    enableContentSecurityPolicyReportOnly: false,

    cspScriptSrc: [],
    cspScriptSrcBase: [],
    cspScriptSrcTest: [],
    cspScriptSrcProd: [],
    cspScriptSrcTestExtra: [],
    cspScriptSrcProdExtra: [],

    cspConnectSrc: [],
    cspConnectSrcBase: [],
    cspConnectSrcTest: [],
    cspConnectSrcProd: [],

    cspFrameSrc: [],

    cspStyleSrc: [],

    allowTestEnvScriptSources: false,

    //Disable tickets on the results page for a specific TOC between certain dates
    disabledServices: [
        {
            tocCode: 'SN',
            startDate: '2017-01-10 00:00:00',
            endDate: '2017-01-11 23:59:59',
            message: 'global.strike.message',
        },
        {
            tocCode: 'SN',
            startDate: '2017-01-13 00:00:00',
            endDate: '2017-01-13 23:59:59',
            message: 'global.strike.message',
        },
        {
            tocCode: 'SN',
            startDate: '2017-01-23 00:00:00',
            endDate: '2017-01-23 23:59:59',
            message: 'global.strike.message',
        },
    ],

    enableKentRover: false,
    roversRangersTicketTypes: [
        { code: '14R', name: 'roversRangers.ticketTypeName.14R' },
        { code: 'R07', name: 'roversRangers.ticketTypeName.R07' },
        { code: 'MTR', name: 'roversRangers.ticketTypeName.MTR' },
    ],

    // Feature flags for TOC Family promotion
    enableTPERover: false,
    enableTPEStaffRover: false,
    enableStaffDiscounts: false,
    staffYearlyAllowance: 40,
    tocFamilyTermsAndConditionsUrl: '#',

    railcard1617GracePeriod: { months: 4 },

    // refund widget
    enableRefundWidgetPoweredBy: false,

    // delay repay
    delayRepayFaq:
        'https://www.thameslinkrailway.com/help-and-support/contact-us/faqs/delays-and-compensation',
    delayRepayMaxTicketDays: 28,
    delayRepayMaxClaims: 5,
    delayRepayStations: null,
    delayRepayVia: true,
    delayRepayMaxUploadMb: 5,
    delayRepayMinUploadMb: 0.01,
    delayRepayUploadTypes: ['application/pdf', 'image/jpeg', 'image/png'],
    delayRepayPaymentLogo: false,
    delayRepayArrivalTime: true,
    delayRepayResponseTime: 24,
    delayRepayResponseUnits: 'hours', // hours|minutes|days
    delayRepayClaimMaxDate: false,
    delayRepayPaperRequiresMoreInfo: false,
    showGroupStations: false,

    hideBookingRailcardTutorial: true,

    delayRepayTickets: [
        {
            id: DelayRepayTicket.SEASON_ANNUAL,
            group: 'season',
            ticketNumber: true,
            photocardNumber: true,
            ticketUpload: true,
            allowPreviousUpload: true,
        },
        {
            id: DelayRepayTicket.SEASON_MONTHLY,
            group: 'season',
            ticketNumber: true,
            photocardNumber: true,
            ticketUpload: true,
            allowPreviousUpload: true,
        },
        {
            id: DelayRepayTicket.SEASON_WEEKLY,
            group: 'season',
            ticketNumber: true,
            photocardNumber: true,
            ticketUpload: true,
        },
        {
            id: DelayRepayTicket.SEASON_OTHER,
            group: 'season',
            ticketNumber: true,
            photocardNumber: true,
            ticketUpload: true,
            allowPreviousUpload: true,
        },
        { id: DelayRepayTicket.SINGLE, group: 'non-season', ticketNumber: true, ticketUpload: true },
        { id: DelayRepayTicket.RETURN, group: 'non-season', ticketNumber: true, ticketUpload: true },
        {
            id: DelayRepayTicket.ETICKET_SINGLE,
            group: 'electronic',
            ticketNumber: false,
            ticketUpload: true,
        },
        {
            id: DelayRepayTicket.ETICKET_RETURN,
            group: 'electronic',
            ticketNumber: false,
            ticketUpload: true,
        },
        { id: DelayRepayTicket.SMART_KEY, group: 'contactless', smartcardNumber: true },
        {
            id: DelayRepayTicket.SEASON_OYSTER,
            group: 'contactless',
            ticketNumber: false,
            statementUpload: true,
            allowPreviousUpload: true,
        },
        { id: DelayRepayTicket.SMART_PAYGO, group: 'contactless', statementUpload: true },
        {
            id: DelayRepayTicket.SMART_OTHER,
            group: 'contactless',
            statementUpload: true,
            contactlessNumber: true,
        },
    ],

    delayRepayReasons: [
        { id: DelayRepayClaimReason.DELAYED_DEPARTURE },
        { id: DelayRepayClaimReason.DELAYED_ON_ROUTE },
        { id: DelayRepayClaimReason.TRAIN_CANCELLED, moreDetailsOptional: true },
        { id: DelayRepayClaimReason.MISSED_CONNECTION },
        {
            id: DelayRepayClaimReason.RESUBMITTED_CLAIM,
            moreDetailsRequired: true,
            maxTicketDays: 180,
        },
        // other available reasons
        // { id: DelayRepayClaimReason.STRIKE_ACTION },
        // {id: DelayRepayClaimReason.OTHER, moreDetailsRequired: true},
    ],

    delayRepayTimes: [
        { id: 'short', value: '30-59' },
        { id: 'medium', value: '60-119' },
        { id: 'long', value: '120' },
    ],

    delayRepayBankable: false,

    delayRepayPaymentMethods: [
        {
            id: DelayRepayPaymentMethod.BACS,
            requiresAccount: false,
            isBankable: true,
            countries: ['GBR'],
        },
        {
            id: DelayRepayPaymentMethod.EVOUCHER,
            requiresAccount: true,
            isBankable: false,
        },
        {
            id: DelayRepayPaymentMethod.PAYPAL,
            requiresAccount: true,
            isBankable: true,
        },
        {
            id: DelayRepayPaymentMethod.CHARITY,
            requiresAccount: false,
            isBankable: true,
            isOtherType: false,
            countries: ['GBR'],
        },
        {
            id: DelayRepayPaymentMethod.VOUCHER,
            requiresAccount: false,
            isBankable: true,
            isOtherType: true,
            message: 'delayrepay.paymentMethod.message.longer',
            countries: ['GBR'],
        },
        /* Temporarily disabling CHEQUE
        {
            id: DelayRepayPaymentMethod.CHEQUE,
            requiresAccount: false,
            isBankable: true,
            isOtherType: true,
            message: 'delayrepay.paymentMethod.message.longer',
            countries: ['GBR']
        }
        */
    ],

    delayRepayCharities: [
        {
            imageUrl: '/images/charity-railway-children.png',
            name: 'railway-children',
            text: 'delayrepay.charities.texts.railway-children',
            title: 'Railway Children',
            website: 'https://www.railwaychildren.org.uk/',
            linkText: 'www.railwaychildren.org.uk',
        },
        {
            imageUrl: '/images/charity-samaritans.png',
            name: 'samaritans',
            text: 'delayrepay.charities.texts.samaritans',
            title: 'Samaritans',
            website: 'https://www.samaritans.org/',
            linkText: 'www.samaritans.org',
        },
        {
            imageUrl: '/images/charity-nhs.png',
            name: 'nhs',
            text: 'delayrepay.charities.texts.nhs',
            title: 'NHS',
            website: 'https://www.nhscharitiestogether.co.uk/what-we-do/',
            linkText: 'www.nhscharitiestogether.co.uk',
        },
    ],

    autoDelayRepayPaymentMethods: [
        { id: DelayRepayPaymentMethod.BACS, requiresAccount: false, countries: ['GBR'] },
        { id: DelayRepayPaymentMethod.EVOUCHER, requiresAccount: true, disabled: false },
        { id: DelayRepayPaymentMethod.PAYPAL, requiresAccount: true },
        { id: DelayRepayPaymentMethod.CHARITY, requiresAccount: false, isBankable: true },
    ],

    compensationPhoneNumber: '0345 0264 700',
    compensationHelpUrl: 'https://railcompensation.thameslinkrailway.com/',
    compensationFaqUrl: 'https://railcompensation.thameslinkrailway.com/faq',
    compensationEligibilityCheckerUrl:
        'https://railcompensation.thameslinkrailway.com/check-eligibility',
    compensationMinDuration: { weeks: 1 },
    compensationMinDurationPerRoute: { weeks: 1 },
    compensationMaxRoutes: 8,
    compensationMaxTicketsPerRoute: 5,
    compensationMaxTotalBookSize: 10,
    compensationMinTicketsPerWeek: 3,
    compensationMaxTicketsPerWeek: 5,
    compensationMinWeeks: 1,
    compensationMaxWeeks: 4,
    compensationMaxWeeksWithCarnet: 2,
    compensationMaxWeeksLevel2: 1,
    compensationStartDate: '2018-05-20',
    compensationEndDate: '2018-07-28',
    compensationNonSeasonStartDate: '2018-05-21',
    compensationNonSeasonEndDate: '2018-07-29',
    compensationStartDayOfWeek: 'monday',
    compensationTickets: [
        {
            id: CompensationTicket.STANDARD,
            class: DelayRepayTicketClass.STANDARD,
            ticketNumber: true,
            photocardNumber: true,
            dates: true,
            price: true,
            purchaseLocation: true,
            ticketUpload: true,
        },
        {
            id: CompensationTicket.FIRST_CLASS,
            class: DelayRepayTicketClass.FIRST_CLASS,
            ticketNumber: true,
            photocardNumber: true,
            dates: true,
            price: true,
            purchaseLocation: true,
            ticketUpload: true,
        },
        {
            id: CompensationTicket.SMART_KEY,
            smartcardNumber: true,
            price: true,
            dates: true,
        },
        {
            id: CompensationTicket.SMART_PAYGO,
            weeklyCap: true,
            fixedDuration: { days: 7 },
            dates: true,
            statementUpload: true,
            requiresUpload: true,
            price: false,
        },
        {
            id: CompensationTicket.SMART_OTHER,
            contactlessNumber: true,
            statementUpload: true,
            requiresUpload: true,
            price: true,
            dates: true,
        },
        {
            id: CompensationTicket.SEASON_OYSTER,
            oysterNumber: true,
            statementUpload: true,
            requiresUpload: true,
            uploadHint: true,
            price: true,
            dates: true,
        },
    ],

    compensationNonSeasonTickets: [
        {
            id: CompensationTicket.SINGLE,
            stations: true,
            price: true,
            ticketNumber: true,
            purchaseLocation: true,
            pairWithOther: true,
            pairWithSelf: true,
        },
        {
            id: CompensationTicket.RETURN,
            stations: true,
            price: true,
            ticketNumber: true,
            purchaseLocation: true,
            pairWithOther: false,
            pairWithSelf: false,
        },
        {
            id: CompensationTicket.CARNET,
            stations: true,
            price: true,
            ticketNumber: true,
            purchaseLocation: true,
            bookSize: true,
            pairWithSelf: true,
            pairWithOther: false,
            returnMustMatch: true,
            weeklyExclusive: true,
        },
        {
            id: CompensationTicket.FREEDOM_PASS,
            stations: true,
            pairWithOther: true,
            pairWithSelf: false,
        },
        {
            id: CompensationTicket.CONTACTLESS_BANK,
            price: true,
            stations: true,
            pairWithOther: true,
            pairWithSelf: true,
        },
        {
            id: CompensationTicket.OYSTER_PAYG,
            stations: true,
            oysterNumber: true,
            pairWithOther: true,
            pairWithSelf: true,
            evidenceIsOptional: true,
        },
        {
            id: CompensationTicket.CONTACTLESS_KEY,
            smartcardNumber: true,
            pairWithOther: true,
            pairWithSelf: true,
            optionalReturn: true,
            evidenceNotRequired: true,
        },
    ],

    compensationEvidence: [
        { id: CompensationEvidence.TICKET_IMAGE },
        { id: CompensationEvidence.TICKET_RECEIPT },
        { id: CompensationEvidence.BANK_STATEMENT, allowPreviousUpload: true },
        { id: CompensationEvidence.JOURNEY_HISTORY, allowPreviousUpload: true },
        { id: CompensationEvidence.OTHER, comments: true },
        { id: CompensationEvidence.NONE, comments: true },
        { id: CompensationEvidence.TICKET_MIXTURE, comments: true, onlyFor: [CompensationTicket.CARNET] },
        { id: CompensationEvidence.FREEDOM_PASS_IMAGE, allowPreviousUpload: true, onlyFor: [CompensationTicket.FREEDOM_PASS] }
    ],

    compensationDurations: fromJS([
        DurationTypes.WEEKLY,
        DurationTypes.MONTHLY,
        DurationTypes.ANNUAL,
        DurationTypes.CUSTOM,
    ]),
    compensationCpayWeeklyCaps: fromJS([
        { name: 'Zones 1-3', price: 2790 },
        { name: 'Zones 1-4', price: 3420 },
        { name: 'Zones 1-5', price: 4070 },
        { name: 'Zones 1-6', price: 4360 },
        { name: 'Zones 2-3', price: 1780 },
        { name: 'Zones 2-4', price: 1970 },
        { name: 'Zones 2-5', price: 2370 },
        { name: 'Zones 2-6', price: 2980 },
        { name: 'Zone 3 only', price: 1780 },
        { name: 'Zones 3-4', price: 1780 },
        { name: 'Zones 3-5', price: 1970 },
        { name: 'Zones 3-6', price: 2370 },
        { name: 'Zone 4 only', price: 1780 },
        { name: 'Zones 4-5', price: 1780 },
        { name: 'Zones 4-6', price: 1970 },
        { name: 'Zone 5 only', price: 1780 },
        { name: 'Zones 5-6', price: 1780 },
    ]),

    compensationPurchaseLocations: [
        { id: CompensationPurchaseLocations.STATION, requiresStation: true },
        { id: CompensationPurchaseLocations.WEBSITE },
        { id: CompensationPurchaseLocations.OTHER, requiresOther: true },
    ],

    compensationPaymentMethods: [
        {
            id: DelayRepayPaymentMethod.BACS,
            requiresAccount: false,
            isBankable: true,
            countries: ['GBR'],
        },
        {
            id: DelayRepayPaymentMethod.EVOUCHER,
            requiresAccount: true,
            isBankable: false,
            disabled: false,
        },
    ],

    tutorials: [
        {
            name: Tutorials.JP_GRID,
            currentIndex: 0,
            dismissed: false,
            defaultOpen: false,
            stages: [
                {
                    name: JPGridTutorialStages.INTRO,
                    title: 'jp-grid-tutorial.intro.title',
                    text: 'jp-grid-tutorial.intro.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.TABS,
                    title: 'jp-grid-tutorial.tabs.title',
                    text: 'jp-grid-tutorial.tabs.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.GRID_VIEW,
                    title: 'jp-grid-tutorial.grid-view.title',
                    text: 'jp-grid-tutorial.grid-view.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.LIST_VIEW,
                    title: 'jp-list-tutorial.list-view.title',
                    text: 'jp-list-tutorial.list-view.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.SERVICE_CAROUSEL,
                    title: 'jp-grid-tutorial.service-carousel.title',
                    text: 'jp-grid-tutorial.service-carousel.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.SERVICE_INFO,
                    title: 'jp-grid-tutorial.service-info.title',
                    text: 'jp-grid-tutorial.service-info.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.TICKET_CATEGORIES,
                    title: 'jp-grid-tutorial.ticket-categories.title',
                    text: 'jp-grid-tutorial.ticket-categories.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.TICKET_DETAILS,
                    title: 'jp-grid-tutorial.ticket-details.title',
                    text: 'jp-grid-tutorial.ticket-details.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.PREFERENCES,
                    title: 'jp-grid-tutorial.preferences.title',
                    text: 'jp-grid-tutorial.preferences.text',
                    image: true,
                },
            ],
        },
        {
            name: Tutorials.JP_LIST,
            currentIndex: 0,
            dismissed: false,
            defaultOpen: false,
            stages: [
                {
                    name: JPListTutorialStages.INTRO,
                    title: 'jp-list-tutorial.intro.title',
                    text: 'jp-list-tutorial.intro.text',
                    image: true,
                },
                {
                    name: JPListTutorialStages.TABS,
                    title: 'jp-list-tutorial.tabs.title',
                    text: 'jp-list-tutorial.tabs.text',
                    image: true,
                },
                {
                    name: JPListTutorialStages.LIST_VIEW,
                    title: 'jp-list-tutorial.list-view.title',
                    text: 'jp-list-tutorial.list-view.text',
                    image: true,
                },
                {
                    name: JPListTutorialStages.GRID_VIEW,
                    title: 'jp-grid-tutorial.grid-view.title',
                    text: 'jp-grid-tutorial.grid-view.text',
                    image: true,
                },
                {
                    name: JPListTutorialStages.SELECT_SERVICE,
                    title: 'jp-list-tutorial.select-service.title',
                    text: 'jp-list-tutorial.select-service.text',
                    image: true,
                },
                {
                    name: JPListTutorialStages.SERVICE_INFO,
                    title: 'jp-list-tutorial.service-info.title',
                    text: 'jp-list-tutorial.service-info.text',
                    image: true,
                },
                {
                    name: JPListTutorialStages.SELECT_FARE,
                    title: 'jp-list-tutorial.select-fare.title',
                    text: 'jp-list-tutorial.select-fare.text',
                    image: true,
                },
                {
                    name: JPListTutorialStages.TICKET_DETAILS,
                    title: 'jp-list-tutorial.ticket-details.title',
                    text: 'jp-list-tutorial.ticket-details.text',
                    image: true,
                },
                {
                    name: JPListTutorialStages.RETURN_SERVICE,
                    title: 'jp-list-tutorial.return-service.title',
                    text: 'jp-list-tutorial.return-service.text',
                    image: true,
                },
                {
                    name: JPGridTutorialStages.PREFERENCES,
                    title: 'jp-list-tutorial.preferences.title',
                    text: 'jp-list-tutorial.preferences.text',
                    image: true,
                },
            ],
        },
        {
            name: Tutorials.SEASONS,
            currentIndex: 0,
            dismissed: false,
            defaultOpen: false,
            stages: [
                {
                    name: SeasonsTutorialStages.INTRO,
                    title: 'seasons-tutorial.intro.title',
                    text: 'seasons-tutorial.intro.text',
                    image: true,
                },
                {
                    name: SeasonsTutorialStages.FILTERS,
                    title: 'seasons-tutorial.filters.title',
                    text: 'seasons-tutorial.filters.text',
                    image: true,
                },
                {
                    name: SeasonsTutorialStages.COMPARISON,
                    title: 'seasons-tutorial.comparison.title',
                    text: 'seasons-tutorial.comparison.text',
                    image: true,
                },
            ],
        },
        {
            name: Tutorials.STATION_FINDER,
            currentIndex: 0,
            dismissed: false,
            defaultOpen: false,
            stages: [
                {
                    name: StationFinderTutorialStages.INTRO,
                    title: 'station-finder.intro.title',
                    text: 'station-finder.intro.text',
                    image: true,
                },
                {
                    name: StationFinderTutorialStages.ORIGIN_DESTINATION,
                    title: 'station-finder.origin-destination.title',
                    text: 'station-finder.origin-destination.text',
                    image: true,
                },
            ],
        },
        {
            name: Tutorials.SMARTCARD,
            currentIndex: 0,
            dismissed: false,
            defaultOpen: true,
            hideProgression: true,
            stages: [
                {
                    name: SmartcardTutorial.INTRO,
                    title: 'booking.smartcard.info.header',
                    text: 'booking.smartcard.info.body',
                },
            ],
        },
        {
            name: Tutorials.RAILCARD,
            currentIndex: 0,
            dismissed: false,
            defaultOpen: true,
            hideProgression: true,
            stages: [
                {
                    name: RailcardTutorial.INTRO,
                    title: 'booking.tutorial.railcard',
                    text: 'booking.tutorial.railcard',
                },
            ],
        },
    ],

    //Feature Flags - inApp
    enableInAppMode: false,
    enableAppUpdateAlertPopup: true,
    enableSmartcardInfoInApp: true,

    // pay attention to the version with 2 digits, 2.6 it means 2.6.x
    unsupportedAppVersions: {
        iOS: '2.6.0 || 2.5.0',
        Android: '2.8.1 || 2.8.0 || 2.6.0 || 2.5.0',
    },

    gaAjaxHandlerAppVersion: '> 2.9.1',

    // -- Google Optimize
    featureExperimentIds: null,
    featureVariants: null,
    // -- end: Google Optimize

    // external JP widget
    jpWidgetStylesheetUrl: null,

    externalRegistrationLink: null,

    showNRETicketLink: true,
    hasFooterPoweredByOn: false,
    poweredByUrl: 'https://www.ontrackretail.co.uk/',

    flexiHelpUrl: null,
    keyGoFlexiExplainedUrl: null,
    flexiNoResultsLink: null,

    digitalRailcardsPortalUrl: null,

    // NRE Handoff
    enableNREHandoffLogging: false,
    journeyPlannerNREStagingUrl: 'https://nreojp.staging.nationalrail.co.uk',
    journeyPlannerNREUrl: 'https://ojp.nationalrail.co.uk',

    // Webchat
    enableWebchat: false,
    webchatIframeSrc: '',
    webchatProhibitedPaths: [
        '/search',
        '/season-tickets',
        '/journeys-list/',
        '/journeys-grid/',
        '/delivery',
        '/payment',
        '/account',
    ],

    // Map default center coords
    defaultMapCenter: {
        lat: 51.505,
        lng: -0.09,
    },

    googlePayEnvironment: 'TEST',
};

class Config extends record(defaults) {
    static resolveAll(list, RecordType) {
        if (list) {
            return fromJS(list).map(item => RecordType.fromJSON(item.toJS ? item.toJS() : item));
        }
        return list;
    }

    static fromJS(json = {}) {
        const resolved = Object.assign(json, {
            journeySelectorOptions: fromJS(json.journeySelectorOptions),
            journeySelectorAdditionalOptions: fromJS(json.journeySelectorAdditionalOptions),
            serviceProviders: fromJS(json.serviceProviders),
            disabledServices: Config.resolveAll(json.disabledServices, DisabledService),
            delayRepayStations: fromJS(json.delayRepayStations),
            delayRepayTickets: Config.resolveAll(json.delayRepayTickets, DelayRepayTicketType),
            delayRepayReasons: Config.resolveAll(json.delayRepayReasons, DelayRepayReason),
            delayRepayTimes: Config.resolveAll(json.delayRepayTimes, DelayRepayTime),
            delayRepayPaymentMethods: Config.resolveAll(
                json.delayRepayPaymentMethods,
                DelayRepayPaymentRecord,
            ),
            compensationPaymentMethods: Config.resolveAll(
                json.compensationPaymentMethods,
                DelayRepayPaymentRecord,
            ),
            compensationTickets: Config.resolveAll(
                json.compensationTickets,
                CompensationTicketType,
            ),
            compensationNonSeasonTickets: Config.resolveAll(
                json.compensationNonSeasonTickets,
                CompensationNonSeasonTicketType,
            ),
            compensationEvidence: Config.resolveAll(
                json.compensationEvidence,
                CompensationEvidenceType,
            ),
            compensationPurchaseLocations: Config.resolveAll(
                json.compensationPurchaseLocations,
                CompensationPurchaseLocation,
            ),
            autoDelayRepayPaymentMethods: Config.resolveAll(
                json.autoDelayRepayPaymentMethods,
                DelayRepayPaymentRecord,
            ),
            tutorials: Config.resolveAll(json.tutorials, Tutorial),
            featureVariants: fromJS(json.featureVariants),
            featureExperimentIds: fromJS(json.featureExperimentIds),
        });
        return new Config(resolved);
    }
}

let instance = new Config();

export default {
    has(key) {
        return instance.has(key);
    },

    get(key, def = null) {
        return instance.get(key, def);
    },

    set(key, value) {
        if (!window.jasmine) {
            console.warn('Called config.set, this should only be used in tests');
        }
        instance = instance.set(key, value);
    },

    keys() {
        return instance.keySeq();
    },

    init(options = {}) {
        const { invalidKeys, validOptions } = Object.keys(options).reduce(
            (acc, key) => {
                if (key in defaults) {
                    acc.validOptions[key] = options[key];
                } else {
                    acc.invalidKeys.push(key);
                }
                return acc;
            },
            { invalidKeys: [], validOptions: {} }
        );
        if (invalidKeys.length > 0) {
            invalidKeys.forEach(key => {
                console.warn(`'${key}' is not a valid config option and will be ignored`);
            });
        }
        instance = Config.fromJS({ ...defaults, ...validOptions });
    },

    toJS() {
        return instance.toJS();
    },
};
